(function() {
    'use strict';

    angular
        .module('app')
        .directive('exportMenu', exportMenu);

    exportMenu.$inject = ['$window', '$timeout'];
    
    function exportMenu ($window, $timeout) {
        // Usage:
        //     <exportMenu></exportMenu>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/exportmenu/templates/exportmenu.html',
            controller: 'exportMenu as vm',
            scope: {
                onMenuClick: "=?",
                exportColumns: "=?"
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var w = angular.element($window);
            scope.$watch(function () {
                return scope.show;
            }, function (value) {
                if (value) {
                    $timeout(function () {
                        w.bind('click', windowBind);
                    });
                }
                else {
                    w.unbind('click');
                }
            })


            var windowBind = function (e) {
                if (!$(e.target).closest(".export-popup").length) {
                    scope.show = false;
                    scope.$apply();
                }
            }

        }
    }

})();